import moment, { Moment } from 'moment';

export type ServiceStatus = 'OK' | 'DUE SOON' | 'OVERDUE';

export interface ServiceRecordFormValues {
  vehicle_no: string;
  meterReading: string | number;
  date: Moment | null;
  nextServiceDate: Moment | null;
  nextServiceMeterReading: string | number;
}

export interface ServiceRecordPayload {
  vehicle_id: number;
  odo_meter_reading_km: number | null;
  serviced_date: string | null;
  next_service_date: string | null;
  next_service_odo_meter_reading_km: number | null;
}

export interface ServiceRecordDTO {
  id: string;
  vehicle_id: number;
  odo_meter_reading_km: number;
  serviced_date: string | null;
  next_service_date: string | null;
  next_service_odo_meter_reading_km: number | null;
  created_at: string;
  updated_at: string;
}

const toNumberOrNull = (value: string | number | null | undefined): number | null =>
  value === '' || value === null || value === undefined ? null : Number(value);

export const formValuesToPayload = (v: ServiceRecordFormValues, vehicleId: number): ServiceRecordPayload => ({
  vehicle_id: vehicleId,
  odo_meter_reading_km: toNumberOrNull(v.meterReading),
  serviced_date: v.date ? `${v.date.utc().format('YYYY-MM-DDTHH:mm:ss')}Z` : null,
  next_service_date: v.nextServiceDate ? `${v.nextServiceDate.utc().format('YYYY-MM-DDTHH:mm:ss')}Z` : null,
  next_service_odo_meter_reading_km: toNumberOrNull(v.nextServiceMeterReading),
});

export const recordToFormValues = (r: ServiceRecordDTO, plate: string): ServiceRecordFormValues => ({
  vehicle_no: plate,
  meterReading: r.odo_meter_reading_km ?? '',
  date: r.serviced_date ? moment(r.serviced_date) : null,
  nextServiceDate: r.next_service_date ? moment(r.next_service_date) : null,
  nextServiceMeterReading: r.next_service_odo_meter_reading_km ?? '',
});

export type ServiceRecordUpdatePayload = {
  odo_meter_reading_km: number | null;
  serviced_date: string | null;
  next_service_date: string | null;
  next_service_odo_meter_reading_km: number | null;
  vehicle_id: number;
};

export const formValuesToUpdatePayload = (
  v: ServiceRecordFormValues,
  vehicleId: number,
): ServiceRecordUpdatePayload => ({
  odo_meter_reading_km: toNumberOrNull(v.meterReading),
  serviced_date: v.date ? `${v.date.utc().format('YYYY-MM-DDTHH:mm:ss')}Z` : null,
  next_service_date: v.nextServiceDate ? `${v.nextServiceDate.utc().format('YYYY-MM-DDTHH:mm:ss')}Z` : null,
  next_service_odo_meter_reading_km: toNumberOrNull(v.nextServiceMeterReading),
  vehicle_id: vehicleId,
});

export default ServiceRecordFormValues;
